import http from './http'

function cleanListParams(params) {
  if (params == null || params === '') return {}
  if (typeof params === 'string') return params ? { status: params } : {}
  const out = {}
  for (const [key, value] of Object.entries(params)) {
    if (value === '' || value == null || value === false) continue
    out[key] = value
  }
  return out
}

export function listPosts(params = {}) {
  return http.get('/posts', { params: cleanListParams(params) })
}

export function getPost(id) {
  return http.get(`/posts/${id}`)
}

export function getPostComments(id) {
  return http.get(`/posts/${id}/comments`)
}

export function updateCommentAutomation(id, payload) {
  return http.put(`/posts/${id}/comment-automation`, payload)
}

export function replyPostComment(id, payload) {
  return http.post(`/posts/${id}/comments/reply`, payload)
}

export function createPost(payload) {
  return http.post('/posts', payload)
}

export function updatePost(id, payload) {
  return http.put(`/posts/${id}`, payload)
}

export function schedulePost(id, payload) {
  return http.post(`/posts/${id}/schedule`, payload)
}

export function publishPost(id) {
  return http.post(`/posts/${id}/publish`)
}

export function deletePost(id) {
  return http.delete(`/posts/${id}`)
}

export function approvePost(id, payload = {}) {
  return http.post(`/posts/${id}/approve`, payload)
}

export function rejectPost(id, payload) {
  return http.post(`/posts/${id}/reject`, payload)
}

export function listPendingApproval() {
  return http.get('/posts/pending')
}

export function uploadMedia(file) {
  const formData = new FormData()
  formData.append('file', file)
  return http.post('/media/upload', formData, {
    headers: { 'Content-Type': undefined },
  })
}
